import { z } from "zod";
import { VALIDATION_MESSAGES, VALIDATION_LIMITS } from "../constants";
import { requiredString } from "../utils/validationUtils";

export const loginSchema = z.object({
  username: z
    .string()
    .min(
      VALIDATION_LIMITS.USERNAME_MIN_LENGTH,
      VALIDATION_MESSAGES.LENGTH.USERNAME_MIN
    ),
  password: z
    .string()
    .min(
      VALIDATION_LIMITS.PASSWORD_MIN_LENGTH,
      VALIDATION_MESSAGES.LENGTH.PASSWORD_MIN
    ),
});

export const setPasswordSchema = z.object({
  new_password: requiredString("Password baru tidak boleh kosong")
    .min(
      VALIDATION_LIMITS.PASSWORD_MIN_LENGTH,
      VALIDATION_MESSAGES.LENGTH.PASSWORD_MIN
    )
    .max(
      VALIDATION_LIMITS.PASSWORD_MAX_LENGTH,
      VALIDATION_MESSAGES.LENGTH.PASSWORD_MAX
    )
    .regex(/^\S*$/, "Password tidak boleh ada spasi"),
  access_token: z.string(),
});
